<template>
  <div class="keyperson-container row-padding">
    <div class="keyperson-table">
      <div class="table-header">
        <div class="column-0" v-show="isBatch">
          <el-checkbox
            class="checked"
            :indeterminate="isIndeterminate"
            v-model="currentAllChecked"
          ></el-checkbox>
        </div>
        <div class="column-1">昵称</div>
        <div class="column-2">备注</div>
        <div class="column-3">来源</div>
        <div class="column-4">操作</div>
      </div>
      <div class="table-content">
        <ul class="keyperson-list" v-if="currentList.length">
          <li
            class="list-item"
            data-type="0"
            v-for="(item, index) in currentList"
            :key="index"
          >
            <div
              class="keyperson-item"
              @touchstart.capture="touchStart"
              @touchend.capture="touchEnd"
              @click="toDetail"
            >
              <div class="column-0" v-show="isBatch">
                <el-checkbox
                  class="checked"
                  v-model="item.checked"
                ></el-checkbox>
              </div>
              <div class="column-1">
                <span
                  v-if="item.noble_level > 0"
                  class="noble-icon"
                  :class="`noble-level-${item.noble_level}`"
                ></span>
                <span class="name">{{ item.nickname }}</span>
                <span
                  class="level-icon"
                  :class="`level-icon${item.level}`"
                ></span>
              </div>
              <div class="column-2">
                <input
                  :tabindex="index + 100"
                  class="nickname-custom-input"
                  type="text"
                  placeholder="备注为..."
                  v-model="item.nicknameCustom"
                  @focus="customInputFocus"
                  @blur="customInputBlur"
                />
              </div>
              <div class="column-3">[{{ addFromOptions[item.add_from] }}]</div>
              <div class="column-4">
                <!-- <el-popover
                  placement="bottom"
                  title="欢迎句式设定"
                  width="350"
                  trigger="hover"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    slot="reference"
                    :plain="item.welcomeTpl ? false : true"
                    >特殊欢迎</el-button
                  >
                </el-popover> -->
                <i
                  class="fa-smile-o"
                  title="特殊欢迎句式"
                  :class="{
                    active: item.welcomeTpl,
                  }"
                  @click="editWelcomeTpl(index)"
                ></i>
                <i
                  class="fa-window-close"
                  title="删除这条"
                  @click="removeTotalList(index)"
                ></i>
              </div>
            </div>
            <div class="btn-box flex">
              <div class="btn welcome" @click="editWelcomeTpl(index)">
                特殊欢迎
              </div>
              <div class="btn del" @click="removeTotalList(index)">删除</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-footer">
        <div class="footer-top">
          <div class="count-data">
            <span> 总计：{{ totalCount }}条 </span>
            <span>今日：0 条</span>
          </div>
          <div class="kp-filter">
            <div class="filter-input">
              <input
                v-model="keyPersonFilterValue"
                @keydown.enter="keyPersonListFilter"
                @input="filterInput"
                @focus="isFocus = true"
                @blur="filterInputBlur"
                placeholder="筛选过滤"
              />
              <span v-show="isFocus" class="btn" @click="keyPersonListFilter"
                >查找</span
              >
            </div>
            <el-select
              v-model="pageSize"
              class="pagesize-select"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in pageSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="actions-btn">
            <el-link
              :underline="false"
              type="primary"
              v-show="!isBatch"
              @click="isBatch = true"
              >批量管理</el-link
            >
            <el-link
              :underline="false"
              type="primary"
              v-show="isBatch"
              @click="isBatch = false"
              >完成</el-link
            >
            <el-link
              :underline="false"
              type="primary"
              v-show="isBatch"
              @click="removeAllConfirm"
              >删除选中</el-link
            >
          </div>
          <el-pagination
            small
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            layout="prev, pager, next"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`特别欢迎句式`"
      :width="isPC ? '540px' : '95%'"
      :visible.sync="isShowWlcomeTpl"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-if="isShowWlcomeTpl"
    >
      <Editor
        v-model="welcomeTpl"
        mode="edit"
        :labels="['userNick', 'anchorNick']"
      ></Editor>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveWelcomTpl">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { delKeyPerson } from "@/api/index";
import { configCommon } from "@/mixins/configCommon";
export default {
  mixins: [configCommon],
  data() {
    return {
      keyPersonFilterValue: "",
      searchKeyPersonTimer: null,
      pageSize: 10,
      pageNo: 1,
      isBatch: false,
      currentAllChecked: false,
      isIndeterminate: false,
      isRemoveAllIng: false,
      startX: 0, // 初始位置
      endX: 0, // 结束位置
      isShowWlcomeTpl: false,
      welcomeTpl: "",
      welcomeTplIndex: -1,
      customInputFocusValue: "",
      pageSizeOptions: [
        {
          value: 10,
          label: "10条",
        },
        {
          value: 20,
          label: "20条",
        },
        {
          value: 50,
          label: "50条",
        },
        {
          value: 100,
          label: "100条",
        },
      ],
      addFromOptions: {
        0: "手动",
        1: "消费档",
        2: "粉丝牌",
        3: "周贡榜",
        4: "爵位",
        5: "连麦",
      },
      isFocus: false,
    };
  },
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    currentList: {
      type: Array,
      default: () => [],
    },
    ticket: {
      type: String,
      default: "",
    },
  },
  watch: {
    currentAllChecked(val) {
      if (this.isRemoveAllIng) return;
      if (val) {
        this.currentList.forEach((subval, index) => {
          this.currentList[index].checked = val;
        });
      } else {
        let count = 0;
        this.currentList.forEach((subval, index) => {
          if (subval.checked) {
            count++;
          }
        });
        if (count == this.currentList.length) {
          this.currentList.forEach((subval, index) => {
            this.currentList[index].checked = val;
          });
        }
      }
    },
    currentList: {
      handler: function(val, oldVal) {
        if (this.isRemoveAllIng) return;
        let count = 0;
        val.forEach((val) => {
          if (val.checked) {
            count++;
          }
        });
        if (count === val.length) {
          this.currentAllChecked = true;
          this.isIndeterminate = false;
        } else {
          this.currentAllChecked = false;
          if (count > 0) {
            this.isIndeterminate = true;
          } else {
            this.isIndeterminate = false;
          }
        }
        if (val.length > this.pageSize) {
          this.currentList.splice(this.pageSize, val.length - this.pageSize);
        }
      },
      deep: true,
    },
    pageSize() {
      this.pageNo = 1;
      this.setCurrentPageList();
    },
  },
  mounted() {},
  methods: {
    keyPersonListFilter() {
      console.log(99);
      if (!this.keyPersonFilterValue.length) {
        this.$message.error("请输入筛选的文字");
        return;
      }
      this.pageNo = 1;
      this.setCurrentPageList();
    },
    createKeyPersonFilter(string) {
      return (state) => {
        return (
          state.nickname.toLowerCase().indexOf(string.toLowerCase()) !== -1 ||
          state.nicknameCustom.toLowerCase().indexOf(string.toLowerCase()) !==
            -1
        );
      };
    },
    editWelcomeTpl(index) {
      this.isShowWlcomeTpl = true;
      this.welcomeTpl = this.currentList[index].welcomeTpl;
      this.welcomeTplIndex = index;
    },
    saveWelcomTpl() {
      this.currentList[this.welcomeTplIndex].welcomeTpl = this.welcomeTpl;
      this.isShowWlcomeTpl = false;
    },
    removeTotalList(index) {
      this.delKeyPerson(this.currentList[index], () => {
        this.$message({
          message: "删除成功",
          type: "success",
          duration: 500,
        });
        this.restSlide();
        this.currentList.splice(index, 1);
      });
    }, // 删除列表项
    delKeyPerson(item, cb) {
      delKeyPerson({
        ticket: this.ticket,
        uid: item.uid,
      }).then((res) => {
        if (res.code == 0) {
          cb && cb();
          this.$emit("delNotice");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.setCurrentPageList();
    },
    setCurrentPageList() {
      console.log(this.pageSize);
      setTimeout(() => {
        this.$emit(
          "getKeypersonList",
          this.pageNo,
          this.pageSize,
          this.keyPersonFilterValue
        );
      }, 0);
    },
    removeAllConfirm() {
      let removeList = JSON.parse(JSON.stringify(this.currentList));
      removeList = removeList.filter((item) => item.checked);
      this.$confirm(`确认删除这${removeList.length}条数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO
          this.removeAll();
        })
        .catch(() => {});
    },
    removeAll() {
      let removeList = JSON.parse(JSON.stringify(this.currentList));
      let checkedNum = removeList.filter((val) => val.checked).length;
      console.log(checkedNum);
      let checkedCount = 0;
      removeList.forEach((val, index) => {
        if (val.checked) {
          checkedCount++;
          this.delKeyPerson(val, () => {
            if (checkedCount == checkedNum) {
              this.pageNo = 1;
              this.isBatch = false;
              this.setCurrentPageList();
            }
          });
        }
      });
    }, // 触摸开始
    touchStart(e) {
      // 记录初始位置
      this.startX = e.touches[0].clientX;
    },
    // 触摸结束
    touchEnd(e) {
      if (this.isBatch) return;
      // 当前滑动的父级元素
      let parentElement = e.currentTarget.parentElement;
      // 记录结束位置
      this.endX = e.changedTouches[0].clientX;
      // console.log('结束' + parentElement.dataset.type + '====' + (this.startX - this.endX));

      // 左滑
      if (parentElement.dataset.type == 0 && this.startX - this.endX > 30) {
        this.restSlide();
        parentElement.dataset.type = 1;
      }

      // 右滑
      if (parentElement.dataset.type == 1 && this.startX - this.endX < -30) {
        this.restSlide();
        parentElement.dataset.type = 0;
      }

      this.startX = 0;
      this.endX = 0;
    },
    // 点击详情
    toDetail() {
      if (this.checkSlide()) {
        this.restSlide();
      }
    },
    // 判断当前是否有滑块处于滑动状态
    checkSlide() {
      let listItems = document.querySelectorAll(".list-item");

      for (let i = 0; i < listItems.length; i++) {
        if (listItems[i].dataset.type == 1) {
          return true;
        }
      }
      return false;
    },
    restSlide() {
      let listItems = document.querySelectorAll(".list-item");
      // 复位
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].dataset.type = 0;
      }
    },
    listAddForReset() {
      if (this.isBatch) {
        this.isBatch = false;
      }
      if (this.keyPersonFilterValue.length) {
        this.keyPersonFilterValue = "";
        this.setCurrentPageList();
      }
    },
    customInputFocus(e) {
      this.customInputFocusValue = e.target.value;
    },
    customInputBlur(e) {
      if (this.customInputFocusValue != e.target.value) {
        this.$message.success("备注成功");
      }
    },
    filterInput(e) {
      if (!e.target.value.length) {
        this.pageNo = 1;
        this.setCurrentPageList();
      }
    },
    filterInputBlur() {
      setTimeout(() => {
        this.isFocus = false;
      }, 300);
    },
  },
};
</script>
